import { z } from 'zod';

export const risksSchema = z.object({
  hasRisks: z.string(),
  risks: z.array(z.object({ id: z.string(), label: z.string() })),
  otherRisks: z.string(),
});

export type RiskSchemaType = z.infer<typeof risksSchema>;
